// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"272":"maintenance","388":"result","445":"accessibility","571":"legal-notice","757":"not-found"}[chunkId] + "-legacy." + {"272":"c27b6b58","388":"d9309412","445":"7b9d72d0","571":"830931f5","757":"43017ab2"}[chunkId] + ".js";
};